import React from 'react'
import Link from 'next/link'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  linkHref: string
  selectedCategory: string
}

const CategoryNavigationLinkAll = ({ linkHref, selectedCategory }: Props) => {
  const { translate } = useTranslations()
  return (
    <div className="u-mb-8">
      {selectedCategory === '/' ? (
        <span className='u-fw-bold'>{translate('facetgroup_allcategories')}</span>
      ) : (
        <Link prefetch={false} href={linkHref}>
          {translate('facetgroup_allcategories')}
        </Link>
      )}
    </div>
  )
}

export default CategoryNavigationLinkAll
